import styled from 'styled-components';

const Container = styled.div`
  padding: 75px 20px;
  background: ${({ backgroundColor }) => backgroundColor};
  overflow: hidden;
  position: relative;

  .show {
    display: block;
  }

  .hide {
    position: absolute;
    left: -999em;
  }

  .toggle--switch input {
    cursor: pointer;
    height: 100%;
    opacity: 0;
    position: absolute;
    width: 100%;
    z-index: 100;
  }

  .toggle--switch {
    height: 100px;
    margin: 25px auto 0 auto;
    padding: 10px;
    position: relative;
    width: 500px;
  }

  .toggle--switch label {
    background: #eeeeee;
    border-radius: 50px;
    color: var(--blue-primary);
    display: block;
    font-family: Sofia Pro;
    font-size: 18px;
    font-weight: 500;
    height: 100%;
    position: relative;
    transition: all 0.5s ease;
    width: 100%;
  }

  .toggle--switch label .toggle--toggle {
    border-radius: 2px;
    display: block;
    height: calc(100% - 10px);
    left: 6px;
    position: absolute;
    top: 6px;
    transition: all 0.5s ease;
    width: 50%;
    z-index: 3;
  }

  .toggle--switch label .toggle--toggle:before {
    align-items: center;
    background: var(--white-color);
    border-radius: 50px;
    bottom: 0;
    box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);
    content: '';
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: -2px;
    transition: all 0.5s ease;
    width: auto;
  }

  .toggle--switch input:checked ~ label .toggle--toggle {
    left: calc(50% + -6px);
  }

  .toggle--title {
    text-align: center;
    z-index: 9;
    margin: 0;
  }

  .toggle--title-container {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 50%;
  }

  .toggle--titles {
    height: 100%;
    display: flex;
  }

  .dropdown-select--container {
    display: flex;
    justify-content: center;
  }

  @media (max-width: 576px) {
    .toggle--title {
      padding: 0 10px;
    }

    .toggle--switch {
      width: 100%;
    }
    .ant-select,
    .ant-select .ant-select-selector {
      width: 100% !important;
    }
  }

  @media (min-width: 576px) {
    .ant-select .ant-select-selector {
      width: 500px !important;
    }
  }
`;

export { Container };
